module.exports = __webpack_public_path__ + "img/Savingmoney-amico.c43eccf1.svg";